var _path, _path2, _path3, _path4, _path5, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 190,
    height: 46,
    viewBox: "0 0 190 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 46V7.07693H10.6542L28.4112 38.9231L46.1682 7.07693H56.8224V46H46.1682V17.6923L31.9626 46H24.8598L10.6542 17.6923V46H0Z",
    fill: "#414042"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M74.5794 23H110.093V30.0769H74.5794V31.8462C74.5794 35.7542 77.7599 38.9231 81.6822 38.9231H110.093V46H76.3551C75.7514 46 75.1595 45.9568 74.5794 45.8742C70.3888 45.2766 66.8729 42.5992 65.1209 38.9231C64.3553 37.3151 63.9252 35.5144 63.9252 33.6154V19.4616C63.9252 17.5626 64.3553 15.7619 65.1209 14.1539C66.8729 10.4778 70.3888 7.80035 74.5794 7.20275C75.1595 7.12018 75.7514 7.07693 76.3551 7.07693H110.093V14.1539H81.6822C77.7599 14.1539 74.5794 17.3227 74.5794 21.2308V23Z",
    fill: "#414042"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M169.272 14.1539C167.52 10.4778 164.004 7.80035 159.813 7.20275C159.233 7.12018 158.641 7.07693 158.037 7.07693H127.85H124.299H117.196V46H124.299H127.85H158.037C158.641 46 159.233 45.9568 159.813 45.8742C164.004 45.2766 167.52 42.5992 169.272 38.9231C170.037 37.3151 170.467 35.5144 170.467 33.6154V19.4616C170.467 17.5626 170.037 15.7619 169.272 14.1539ZM159.813 31.8462C159.813 35.7542 156.633 38.9231 152.71 38.9231H127.85V14.1539H152.71C156.633 14.1539 159.813 17.3227 159.813 21.2308V31.8462Z",
    fill: "#414042"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M188.619 17.6923H177.176V46H188.619V17.6923Z",
    fill: "#414042"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M182.897 14.1538C186.82 14.1538 190 10.9854 190 7.07692C190 3.16845 186.82 0 182.897 0C178.974 0 175.794 3.16845 175.794 7.07692C175.794 10.9854 178.974 14.1538 182.897 14.1538Z",
    fill: "url(#paint0_radial)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(184.602 5.00103) scale(9.13294 9.09967)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ABC3E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#4C74B9"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.d8b35d04.svg";
export { ForwardRef as ReactComponent };